import {API_URL, VERSION} from "../config/config";
import Http from "axios";

async function fetchDynamicValues(key) {
    try {
        const response = await Http.get(`${API_URL}${VERSION}` + '/dynamic-values-setup/fetch-all', {
            params: {
                key
            }
        });
        let items = response.data.map((item) => item.value);
        items = items.map(i => i.name);
        items.push('Others');
        return items;
    } catch (e) {
        throw e;
    }
}

export {
    fetchDynamicValues
}
